import styled from 'styled-components';
import Button$1 from './ResetButton.js';
import { rgba } from 'polished';
import React from 'react';

/* eslint-disable no-ternary, no-nested-ternary */
const BACKGROUND_ALPHA = 0.7;

const getPalette = props => {
  let palette = props.theme.palette.primary;

  if (props.secondary) {
    palette = props.theme.palette.secondary;
  }

  if (props.disabled) {
    palette = props.theme.palette.disabled;
  }

  return palette;
};

const getBackground = props => {
  const palette = getPalette(props);
  return props.outlined ? palette.contrast : palette.main;
};

const getBorder = props => {
  const palette = getPalette(props);
  return `1px solid ${palette.main}`;
};

const getColor = props => {
  const palette = getPalette(props);
  return props.outlined ? palette.main : palette.contrast;
};

const Wrapper = styled(Button$1).withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-pzlzbh-0"
})(["align-items:center;background:", ";border:", ";border-radius:3px;color:", ";cursor:", ";display:flex;font-family:", ";font-size:16px;font-weight:", ";justify-content:center;line-height:1.33;padding:", ";transition:0.4s cubic-bezier(0.25,0.46,0.45,0.94);transition-property:background-color,color,opacity;width:", ";&:hover{", " & i,svg{color:", ";}"], getBackground, getBorder, getColor, ({
  disabled
}) => disabled ? "not-allowed" : "pointer", ({
  theme
}) => theme.font.family, ({
  bold
}) => bold ? "700" : "300", ({
  padded
}) => padded ? "15px 42px" : "10px 20px", ({
  expanded
}) => expanded ? "100%" : "auto", props => !props.noHoverHighlight && `background:
      ${props.disabled ? getBackground(props) : rgba(getBackground(props), BACKGROUND_ALPHA)};}`, ({
  outlined,
  theme
}) => outlined ? theme.palette.primary.main : theme.palette.primary.contrast);
const IconEnd = styled.div.withConfig({
  displayName: "styled__IconEnd",
  componentId: "sc-pzlzbh-1"
})(["margin-left:10px;"]);
const IconStart = styled.div.withConfig({
  displayName: "styled__IconStart",
  componentId: "sc-pzlzbh-2"
})(["margin-right:10px;"]);

/* eslint-disable no-ternary */

const Button = ({
  bold,
  buttonType = "button",
  className,
  disabled,
  expanded,
  iconEnd,
  iconStart,
  label,
  noHoverHighlight,
  onClick,
  outlined,
  padded,
  secondary
}) => /*#__PURE__*/React.createElement(Wrapper, {
  bold: bold,
  className: className,
  disabled: disabled,
  expanded: expanded,
  noHoverHighlight: noHoverHighlight,
  onClick: onClick,
  outlined: outlined,
  padded: padded,
  secondary: secondary,
  type: buttonType
}, iconStart ? /*#__PURE__*/React.createElement(IconStart, null, iconStart) : null, label, iconEnd ? /*#__PURE__*/React.createElement(IconEnd, null, iconEnd) : null);

export { Button as B };
